import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useBooking } from '../context/BookingContext';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const { openModal } = useBooking();

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const navLinks = [
    { label: 'Miso Mini', href: '#miso-mini' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <>
      <nav
        data-testid="navbar"
        style={{
          position: 'fixed', top: `${Math.max(0, 36 - scrollY)}px`, left: 0, right: 0, zIndex: 100,
          transition: 'background-color 0.35s ease, border-color 0.35s ease',
          backgroundColor: scrolled ? 'rgba(250,245,239,0.96)' : 'transparent',
          backdropFilter: scrolled ? 'blur(10px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(139,74,48,0.1)' : '1px solid transparent',
        }}
      >
        <div className="container-miso" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px' }}>
          {/* Logo — Canela italic gold */}
          <a
            href="/"
            data-testid="miso-logo"
            style={{
              fontFamily: 'Canela, Georgia, serif',
              fontWeight: 500,
              fontStyle: 'italic',
              fontSize: '24px',
              letterSpacing: '2px',
              color: '#C9A84C',
              textDecoration: 'none',
            }}
          >
            miso
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex" style={{ alignItems: 'center', gap: '28px' }}>
            {navLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                data-testid={`nav-${link.label.replace(/\s+/g, '-').toLowerCase()}`}
                style={{
                  fontFamily: 'Graphik, sans-serif',
                  fontWeight: 700,
                  fontSize: '11px',
                  letterSpacing: '1.5px',
                  textTransform: 'uppercase',
                  color: '#5C2424',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={e => e.target.style.color = '#B85C3A'}
                onMouseLeave={e => e.target.style.color = '#5C2424'}
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={openModal}
              data-testid="nav-book-now-btn"
              className="btn-primary"
              style={{ padding: '10px 20px', fontSize: '11px' }}
            >
              Book Miso Mini
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-btn"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5C2424', padding: '4px' }}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      {/* Mobile overlay */}
      {menuOpen && (
        <div
          data-testid="mobile-menu-overlay"
          style={{
            position: 'fixed', inset: 0, zIndex: 200,
            backgroundColor: '#FAF5EF',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
          }}
        >
          <button
            onClick={() => setMenuOpen(false)}
            style={{ position: 'absolute', top: '20px', right: '24px', background: 'none', border: 'none', cursor: 'pointer', color: '#5C2424' }}
          >
            <X size={28} />
          </button>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '32px' }}>
            {navLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                style={{
                  fontFamily: 'Canela, Georgia, serif',
                  fontWeight: 500,
                  fontSize: '36px',
                  color: '#5C2424',
                  textDecoration: 'none',
                  letterSpacing: '-0.01em',
                }}
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => { setMenuOpen(false); openModal(); }}
              data-testid="mobile-book-now-btn"
              className="btn-primary"
              style={{ marginTop: '8px', padding: '14px 40px' }}
            >
              Book Miso Mini
            </button>
          </div>
        </div>
      )}
    </>
  );
}
